var React = require('react');

function AssetBusiness (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-2-3h24v24H-2z","key":0}),React.createElement("path",{"fill":"#333647","d":"M16.0096154 12v2.016h-2.0192308V12h2.0192308zm0-3.984v1.968h-2.0192308V8.016h2.0192308zm2.0192308 7.968V6H10v2.016h2.0192308v1.968H10V12h2.0192308v2.016H10v1.968h8.0288462zm-10.04807697-12V2.016H6.00961538v1.968h1.97115385zm0 4.032V6H6.00961538v2.016h1.97115385zm0 3.984V9.984H6.00961538V12h1.97115385zm0 3.984v-1.968H6.00961538v1.968h1.97115385zm-3.99038461-12V2.016H1.97115385v1.968h2.01923077zm0 4.032V6H1.97115385v2.016h2.01923077zm0 3.984V9.984H1.97115385V12h2.01923077zm0 3.984v-1.968H1.97115385v1.968h2.01923077zM10 3.984h10V18H0V0h10v3.984z","key":1})]));
}

AssetBusiness.defaultProps = {"viewBox":"0 0 20 18"};

module.exports = AssetBusiness;

AssetBusiness.default = AssetBusiness;
